import { ChatBase } from '@parcel2go/npm-p2g-app';
import { P2GButton, P2GFade } from '@parcel2go/core-ui';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { ReactNode } from 'react';

interface props {
  onButtonShow?: () => void;
  onOpenChat?: () => void;
  label?: string;
  customButton?: ReactNode;
}

const ChatButton = (props: props) =>
  SettingsCache.settings.LiveChatConfiguration || SettingsCache.settings.Features.includes('LiveChat') ? (
    <ChatBase
      onOpenChat={props.onOpenChat}
      onButtonShow={props.onButtonShow}
      children={
        props.customButton ? (
          props.customButton
        ) : (
          <P2GFade in>
            <P2GButton variant="secondary">{props.label}</P2GButton>
          </P2GFade>
        )
      }
    />
  ) : null;

export default ChatButton;
